import React, { useCallback, useEffect } from "react";

import cx from 'classnames';
import { useInView } from 'react-intersection-observer';

import { Button } from "react-bootstrap";

import styles from './infiniteScroll.module.scss';

interface InfiniteScrollProps{
  className?: string,
  children: React.ReactNode,
  loading: boolean | undefined,
  hasMore: boolean | undefined,
  loadMore: () => void,
  loader?: () => React.ReactNode,
  style?: React.CSSProperties
};

export default function InfiniteScroll({ className, children, loading, hasMore, loadMore, loader, style = {} }: InfiniteScrollProps) {
  const { ref, inView } = useInView({
    threshold: 0,
  });

  const loadMoreItems = useCallback(() => {
    if(!loading){
      loadMore();
    }
  }, [loading, loadMore]);

  useEffect(() => {
    if(inView && hasMore){
      loadMoreItems();
    }
  }, [inView, hasMore, loadMoreItems]);

  return (
    <div id='infinite-scroll' className={cx(styles.infiniteScroll, className)} style={style}>
      {children}
      <>
        {loading && loader &&
          <>{loader()}</>
        }

        {hasMore && !loading &&
          <Button ref={ref} className={styles.loadMore} variant='outline'></Button>
        }
      </>
    </div>

  );
}